import React from 'react';
import CTASection from '../components/CTASection';
import Reveal from '../components/Reveal';
import { standards } from '../data/siteData';

const requirementFlow = [
  'Confirm product format and intended use',
  'Discuss size, maturity, grade, or specification needs',
  'Align packaging and shipment expectations',
  'Prepare export details for buyer review'
];

const QualityPage = () => {
  return (
    <main>
      <section className="page-heading">
        <div className="container-custom">
          <Reveal>
            <p className="eyebrow-pill mb-5">Quality & export standards</p>
            <h1 className="page-title">Verification-minded supply for confident coconut importing.</h1>
            <p className="page-intro">
              Quality is communicated through practical process discipline: selection, grading, hygienic handling, packaging readiness, documentation support, and clear buyer updates.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="page-section">
        <div className="container-custom">
          <div className="quality-proof-layout">
            <Reveal>
              <div className="quality-seal">
                <span>S4</span>
                <h2>Export readiness is built into the workflow.</h2>
                <p>Each inquiry is reviewed around product standards, destination needs, packing expectations, shipment timing, and documentation requirements.</p>
                <div className="quality-stamp">
                  <strong>Checked</strong>
                  <small>before shipment discussion</small>
                </div>
              </div>
            </Reveal>

            <div className="quality-lines">
              {standards.map((standard, index) => (
                <Reveal key={standard.title} delay={index * 80}>
                  <article>
                    <span>{String(index + 1).padStart(2, '0')}</span>
                    <div>
                      <h3>{standard.title}</h3>
                      <p>{standard.text}</p>
                      <div className="proof-chips">
                        {standard.proof.map((item) => (
                          <em key={item}>{item}</em>
                        ))}
                      </div>
                    </div>
                  </article>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="page-section section-rule">
        <div className="container-custom">
          <div className="editorial-split">
            <Reveal>
              <div>
                <p className="eyebrow-pill mb-5">Buyer-specific requirements</p>
                <h2 className="section-title mb-5">Quality conversations begin before the shipment is planned.</h2>
                <p className="section-subtitle max-w-xl">
                  Importers and bulk buyers often need product details shaped around market rules, retail expectations, processing use, or packaging preferences. S4CoconutExports keeps those requirements visible before order planning moves forward.
                </p>
              </div>
            </Reveal>

            <Reveal delay={120}>
              <div className="requirement-flow">
                {requirementFlow.map((item, index) => (
                  <article key={item}>
                    <span>{String(index + 1).padStart(2, '0')}</span>
                    <p>{item}</p>
                  </article>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <CTASection
        eyebrow="Quality inquiry"
        title="Share your required grade, packing format, and destination."
        text="A clear specification helps the team respond with better product, packing, and documentation guidance."
        primaryLabel="Send Quality Requirement"
        secondaryLabel="Explore Products"
        secondaryPath="/products"
      />
    </main>
  );
};

export default QualityPage;
